import clsx from 'clsx';
import React from 'react';
import WarningIcon from '../../assets/icons/warning-icon.svg?react';
import Button from '../Button';
import { useButtonSizeLarge } from '../../utils/buttonSizes';
interface DeleteCustomQuestionModalProps {
  otherClasses?: string;
  question: any | null;
  handleClose: () => void;
  handleDeleteQuestion: (e: any | null) => void;
  isDocument?: boolean;
  isLoading: boolean;
}

const DeleteCustomQuestionModal: React.FC<DeleteCustomQuestionModalProps> = ({
  otherClasses,
  question,
  handleClose,
  handleDeleteQuestion,
  isDocument,
  isLoading,
}) => {
  const deleteCustomQuestionModalClasses = clsx(otherClasses);

  const lg = useButtonSizeLarge();

  return (
    <div
      className={deleteCustomQuestionModalClasses}
      data-testid="delete-custom-question-modal"
    >
      <div className="mb-8 flex w-full flex-col items-center gap-2.5 text-center lg:mb-12">
        <WarningIcon className="[&>path]:fill-brand-posh-pink h-12 w-12 md:h-85 md:w-85" />
        <h4 className="text-brand-posh-pink">Are you sure?</h4>
        <p className="text-brand-posh-pink text-lg leading-5 font-normal">
          {isDocument ? (
            <>
              Are you sure you want to remove the document:{' '}
              <strong className="font-bold">{question?.name}</strong>
            </>
          ) : (
            <>
              Are you sure you want to remove the question:{' '}
              <strong className="font-bold">{question?.question}</strong>
            </>
          )}
        </p>
      </div>
      <div className="mt-8 flex flex-col-reverse gap-2.5 sm:grid sm:grid-cols-2 sm:gap-6 lg:mt-12">
        <Button
          otherClasses="!text-brand-posh-pink hover:text-brand-posh-pink hover:border-brand-posh-pink "
          size={lg}
          variant="secondary"
          disable={isLoading}
          onClick={() => handleClose()}
        >
          Cancel
        </Button>
        <Button
          disable={isLoading}
          loading={isLoading}
          otherClasses="bg-brand-posh-pink hover:text-brand-posh-pink hover:bg-transparent hover:border-brand-posh-pink"
          size={lg}
          onClick={() => handleDeleteQuestion(question || null)}
        >
          Delete
        </Button>
      </div>
    </div>
  );
};

export default DeleteCustomQuestionModal;
